import ChangeStudyName from './ChangeStudyName';

export default ChangeStudyName;
